import * as Sentry from '@sentry/vue'
import { extraErrorDataIntegration } from '@sentry/integrations'
import { version } from '~/package.json'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const {
    public: { sentry },
  } = useRuntimeConfig()

  if (!sentry.dsn) {
    return
  }

  // If in development mode, don't initialize
  if (process.env.NODE_ENV === 'development') {
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    release: version,
    dist: process.env.NUXT_PUBLIC_SENTRY_ENVIRONMENT,
    enabled: process.env.NODE_ENV !== 'development',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [window.location.origin],
      }),
      // @ts-ignore
      extraErrorDataIntegration(),
    ],

    // Performance Monitoring
    tracesSampleRate: 1.0, // Change in prod
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })

  nuxtApp.vueApp.config.errorHandler = (error, vm, info) => {
    Sentry.captureException(error, {
      extra: {
        component: vm?.$options?.name || 'Unknown',
        info,
      },
    })
  }
})
